import React from "react";
import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import makeStyles from "@mui/styles/makeStyles";
import { notBlank } from "../../../util/ext";
import { useIsIapReviewer } from "../../../auth/authUtils";

const useStyles = makeStyles(theme => ({
  italic: {
    fontStyle: "italic",
  },
}));

const AllowDownloadCheckbox = props => {
  const { onChange, value, licenseTypeError = null } = props;
  const classes = useStyles();
  const isIapReviewer = useIsIapReviewer();

  return (
    <FormControlLabel
      style={{ marginLeft: 0 }}
      control={
        <Checkbox
          disabled={isIapReviewer}
          color="primary"
          checked={value}
          onChange={onChange}
          name="content-allowDownload"
          inputProps={{ "aria-label": "Select" }}
        />
      }
      label={
        <div style={{ marginTop: notBlank(licenseTypeError) ? 20 : 0 }}>
          <div>Allow this content to download</div>
          <div className={classes.italic}>
            (Open license types ALWAYS allow download)
          </div>
        </div>
      }
    />
  );
};

export default AllowDownloadCheckbox;
